import { useMemo } from 'react';
import { useSelector } from 'react-redux';

const SecurityReportData = () => {
  const securityState = useSelector(state => state.security);

  const securityReportData = useMemo(() => {
    const dataByModel = {};
    const dataByCategory = {};

    // Iterate over each model
    Object.entries(securityState.models ?? {}).forEach(([modelUuid, modelDetails]) => {
      const { scenarios = {}, securityControls = {} } = modelDetails || {};

      // Convert scenarios to risks format for compatibility
      const risks = Object.entries(scenarios).map(([scenarioId, scenario]) => {
        // Extract threat level from attack surface assessments
        const attackSurface = scenario.attackSurface || {};
        const technicalVulns = Object.values(attackSurface).map(surface => surface['Technical Vulnerability']).filter(Boolean);
        const highestThreat = technicalVulns.includes('High') ? 'High' : 
                            technicalVulns.includes('Moderate') ? 'Moderate' : 
                            technicalVulns.includes('Low') ? 'Low' : 'Negligible';

        return {
          risk_id: scenarioId,
          scenario_id: scenarioId,
          name: scenario.name || 'Unnamed Scenario',
          category: 'Security Scenario', // Default category for scenarios
          threat_level: highestThreat, // Add threat_level for RiskLandscape compatibility
          status: scenario.status || 'pending',
          updatedAt: scenario.updatedAt,
          mappedAgents: scenario.mappedAgents || [],
          attributes: scenario.attributes || {},
          attackSurface: scenario.attackSurface || {},
          impact: scenario.impact || {},
          assessmentData: scenario.assessmentData || {}
        };
      });

      // Organize data by model
      dataByModel[modelUuid] = {
        modelUuid,
        risks: risks.map(risk => ({
          ...risk,
          controls: securityControls[risk.scenario_id] || [] // Attach controls using scenario ID
        })),
        controls: securityControls
      };

      // Organize risks by category
      risks.forEach(risk => {
        if (!risk || !risk.category) return; // Skip invalid risks
        
        const category = risk.category.toLowerCase(); // Normalize the category for consistent access
        if (!dataByCategory[category]) {
          dataByCategory[category] = [];
        }
        // Add risk and its associated controls to the category
        dataByCategory[category].push({
          ...risk,
          modelUuid: modelUuid,
          controls: securityControls[risk.scenario_id] || [], // Use scenario ID for controls
        });
      });
    });

    return { dataByModel, dataByCategory };
  }, [securityState]);

  return securityReportData;
};

export default SecurityReportData;